import React, { useState } from 'react';
import { Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const SingleFileUpload = ({onChnageFile,accept,title}) => {
  // State to manage the file list
  const [fileList, setFileList] = useState([]);

  // Handle file selection and changes
  const handleChange = ({ fileList: newFileList }) => {
    // Ensure only one file is kept in the list
    if (newFileList.length > 0) {
      setFileList([newFileList[newFileList.length -1]]); // Keep only the first file
    } else {
      setFileList([]); // Clear the list if no files remain
    }
    console.log('Updated fileList:', newFileList);
    onChnageFile( newFileList[newFileList.length -1] )
  };

  // Handle file removal
  const handleRemove = (file) => {
    console.log('Removed file:', file);
    setFileList([]); // Clear the file list when the file is removed
    return true; // Confirm removal
  };

  return (
    <div>
      <Upload
        fileList={fileList} // Bind to fileList state
        multiple={false} // Restrict to single file selection
        onChange={handleChange} // Handle file addition
        onRemove={handleRemove} // Handle file removal
        beforeUpload={() => false} // Prevent automatic upload to server
        accept={accept} // Restrict to .doc and .docx files
      >
        <Button icon={<UploadOutlined />}>{title}</Button>
      </Upload>
    </div>
  );
};

export default SingleFileUpload;